/*
 * Copyright (c) 2022. Lukas Tschaftary
 *
 * NOTICE:  All information contained herein is, and remains the property of Lukas Tschaftary and his suppliers, if any. 
 * The intellectual and technical concepts contained herein are proprietary to Lukas Tschaftary and its suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law. 
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained from Lukas Tschaftary.
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Manager, Popper, Reference} from "react-popper";
import TextInput from "./TextInput";
import {Transition} from "react-transition-group";
import {Util} from "../Utilities";
import {v4 as uuid} from "uuid";

const transitionStyles = {
    entering: {opacity: 0, height: 20},
    entered: {opacity: 1,},
    exiting: {opacity: 0, height: 30},
    exited: {opacity: 0, height: 0},
};
const defaultStyle = {
    width: 200, height: 323, top: 0,
    display: "inline-block",
    zIndex: 999,
    opacity: 1,
    maxHeight: 200,
    transition: 'height 0.3s, opacity 0.2s',
    overflow: "hidden",
    padding: 0,
    willChange: 'height, opacity' // speed up animation
}

class Select extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: "",
            currentValue: "",
            selectedItem: 0,
            isOpen: false,
            dropdownInstanceId: uuid(),
        }
    }


    componentDidMount() {
        let option = this.props.options.filter(item => item.value === this.props.value?.value || "")[0]
        if (option !== undefined) {
            this.setState({searchValue: option.label, currentValue: option.value,currentColor:option.value})
        } else {
            this.setState({searchValue: "", currentValue: ""})


        }
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (prevProps.options !== this.props.options || prevProps.value?.value !== this.props.value?.value) {
            let option = this.props.options.filter(item => item.value === this.props.value?.value || "")[0]
            if (option !== undefined) {
                this.setState({searchValue: option.label, currentValue: option.value,currentColor:option.value})
            } else {
                this.setState({searchValue: "", currentValue: ""})


            }
        }
    }

    render() {

        return (
            <div className={(this.props.className || "")}
                 style={{position: "static", display: "inline-block", width: this.props.width}}>
                <Manager>
                    <Reference>
                        {({ref}) => (
                            <TextInput
                                value={this.state.searchValue}
                                innerRef={ref}
                                hasArrow={true}
                                hasDot={(this.state.currentColor!==undefined && this.state.currentColor!=="")}
                                dotColor={this.state.currentColor||'rgba(107, 114, 128, 100)'}
                                isReadOnly={this.props.isReadOnly}
                                arrowColor={'rgba(107, 114, 128, 100)'}
                                style={{
                                    width: '100%',
                                    display: "inline-block",
                                    BoxShadow: "none",
                                    border: "none"
                                }}
                                onChange={value => {
                                    // update the input
                                    this.setState({searchValue: value})

                                    // search in list
                                    this.setState((state) => {
                                        let bestScore = 100
                                        let bestIndex = 0
                                        this.props.options.map((option, index) => {
                                            let score = Util.algo.levenshteinDistance(option.label, value)

                                            if (score < bestScore) {
                                                bestScore = score
                                                bestIndex = index
                                            }

                                        })

                                        // scroll to the element in the dropdown
                                        let element = document.getElementById(this.state.dropdownInstanceId + ":I=" + (bestIndex + 1))
                                        if (element !== null) {
                                            let container = document.getElementById(this.state.dropdownInstanceId + ":C")
                                            container.scroll({
                                                top: element.offsetTop - 1 - 35, //scroll to the top of the element + table header
                                                behavior: 'smooth' //auto, smooth, initial, inherit
                                            });
                                        }

                                        return ({selectedItem: (bestIndex + 1)})
                                    })

                                    if(value.length ===0) {
                                        this.props.onChange(null)

                                    }
                                    // update value on correct type
                                    this.props.options.forEach((option) => {
                                        if (option.label === value) {
                                            if (this.props.onChange !== undefined) {
                                                this.props.onChange(option)
                                            }
                                            this.setState({
                                                searchValue: option.label,
                                                currentValue: option.value,
                                                currentColor:option.color,
                                                isOpen: false
                                            })
                                        }
                                    })
                                }}
                                onKeyDown={(event) => {
                                    if (this.state.isOpen === false) {
                                        this.setState({isOpen: true})
                                    }
                                    // Block the up and Down Keys from accessing the Input
                                    if (event.key === "ArrowDown") {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        let dataLength = this.props.options.length
                                        this.setState((state) => {
                                            let newSelectedItemIndex = (dataLength <= state.selectedItem) ? (state.selectedItem) : state.selectedItem + 1

                                            // scroll to the element in the dropdown
                                            let element = document.getElementById(this.state.dropdownInstanceId + ":I=" + newSelectedItemIndex)
                                            if (element !== null) {
                                                let container = document.getElementById(this.state.dropdownInstanceId + ":C")
                                                container.scroll({
                                                    top: element.offsetTop - 1 - 35, //scroll to the top of the element + table header
                                                    behavior: 'smooth' //auto, smooth, initial, inherit
                                                });
                                            }

                                            return ({selectedItem: newSelectedItemIndex})
                                        })

                                    } else if (event.key === "ArrowUp") {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        this.setState((state) => {
                                            let newSelectedItemIndex = (state.selectedItem !== 0) ? state.selectedItem - 1 : 0

                                            // scroll to the element in the dropdown
                                            let element = document.getElementById(this.state.dropdownInstanceId + ":I=" + newSelectedItemIndex)
                                            if (element !== null) {
                                                let container = document.getElementById(this.state.dropdownInstanceId + ":C")
                                                container.scroll({
                                                    top: element.offsetTop - 1 - 35,  //scroll to the top of the element  + table header
                                                    behavior: 'smooth' //auto, smooth, initial, inherit
                                                });
                                            }

                                            return ({selectedItem: newSelectedItemIndex})
                                        })
                                    } else if (event.key === "Enter") {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        let option = this.props.options[this.state.selectedItem - 1]
                                        if (this.props.onChange !== undefined) {
                                            this.props.onChange(option)
                                        }
                                        this.setState({
                                            searchValue: option.label,
                                            currentValue: option.value,
                                            currentColor:option.color,
                                            isOpen: false
                                        })

                                    }
                                }}
                                onClick={() => {
                                    this.setState({isOpen: true})
                                }}
                                onBlur={() => {
                                    setTimeout(() => {
                                        this.setState({isOpen: false})
                                    }, 200)
                                }}
                                placeholder={"---"}
                                onFocusCapture={() => this.setState({isOpen: true})}
                            />

                        )}
                    </Reference>
                    <Transition in={this.state.isOpen} mountOnEnter={true} unmountOnExit={true}
                                timeout={{
                                    appear: 300,
                                    enter: 300,
                                    exit: 400,
                                }}>
                        {state => (
                            <Popper placement="bottom-start" modifiers={[
                                {
                                    name: 'preventOverflow',
                                    options: {
                                        boundary: document.querySelector('#root'),
                                    },
                                },
                                {
                                    name: 'flip',
                                    options: {
                                        fallbackPlacements: ['top-start', 'top-end', 'bottom-end'],
                                        rootBoundary: 'document',
                                        boundary: document.querySelector('#root'),

                                    },
                                }, {
                                    name: "offset",
                                    enabled: true,
                                    options: {
                                        offset: ({placement, reference, popper}) => {
                                            switch (placement) {
                                                case 'top-end':
                                                case 'top-start':
                                                case 'top':
                                                default:
                                                    return [0, 1]


                                            }
                                        },
                                    }
                                }
                            ]}>
                                {({ref, style, placement, arrowProps}) => (
                                    <div ref={ref}
                                         style={{...style, ...{width: "100px", height: "200px", zIndex: 999}}}
                                         data-placement={placement}
                                    >
                                        <div className=" relativ">
                                            <div style={{
                                                ...defaultStyle,
                                                ...transitionStyles[state]
                                            }}
                                                 className=" border border-gray-300 rounded-b bg-white shadow absolute t-0 l-0 z-100">
                                                <div style={{
                                                    width: "100%",
                                                    minHeight: "10px",
                                                }} className={" customScrollbar"} style={{
                                                    overflowY: "scroll",
                                                    height: "200px",
                                                    scrollSnapType: "y mandatory",
                                                    scrollSnapPointsY: "repeat(38px)",
                                                }}
                                                     id={this.state.dropdownInstanceId + ":C"}>

                                                    {this.props.options.map((option, index) => {
                                                        if (option.value === this.state.currentValue) {

                                                            return (
                                                                <div id={this.state.dropdownInstanceId + ":I=" + index}
                                                                     key={this.state.dropdownInstanceId + ":I=" + index}
                                                                     onClick={() => {
                                                                         if (this.props.onChange !== undefined) {
                                                                             this.props.onChange(option)
                                                                         }
                                                                         this.setState({
                                                                             searchValue: option.label,
                                                                             currentValue: option.value,
                                                                             currentColor:option.color,
                                                                             isOpen: false
                                                                         })

                                                                     }}
                                                                     style={{
                                                                         backgroundColor: this.state.selectedItem === index + 1 ? "#E5E7EB" : "",
                                                                         borderLeft: this.state.selectedItem === index + 1 ? "2px solid #2563EB" : "2px solid #ffff",
                                                                         scrollSnapAlign: "start"
                                                                     }}
                                                                     className="relative border p-2 flex flex-col cursor-pointer focus:outline-none bg-indigo-50 border-indigo-200 z-10 hover:bg-gray-50">
                                                                    <div className="flex items-center text-sm">
                                                                    <span
                                                                        className=" font-medium text-indigo-900">{option.label || "[Lable not found]"}</span>
                                                                    </div>
                                                                </div>)

                                                        } else {
                                                            return (
                                                                <div id={this.state.dropdownInstanceId + ":I=" + index}
                                                                     key={this.state.dropdownInstanceId + ":I=" + index}
                                                                     onClick={() => {
                                                                         if (this.props.onChange !== undefined) {
                                                                             this.props.onChange(option)
                                                                         }
                                                                         this.setState({
                                                                             searchValue: option.label,
                                                                             currentValue: option.value,
                                                                             currentColor:option.color,
                                                                             isOpen: false
                                                                         })
                                                                     }}
                                                                     style={{
                                                                         backgroundColor: this.state.selectedItem === index + 1 ? "#E5E7EB" : "",
                                                                         borderLeft: this.state.selectedItem === index + 1 ? "2px solid #2563EB" : "2px solid #ffff",
                                                                         scrollSnapAlign: "start"
                                                                     }}
                                                                     className=" relative border p-2 flex flex-col cursor-pointer  focus:outline-none border-gray-200 hover:bg-gray-50">
                                                                    <div className="flex items-center text-sm">
                                                                    <span
                                                                        className=" font-medium text-gray-900">{option.label || "[Lable not found]"}</span>
                                                                    </div>
                                                                </div>)
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}
                            </Popper>
                        )}
                    </Transition>
                </Manager>
            </div>
        );
    }
}

Select.propTypes = {
    value: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    isReadOnly: PropTypes.bool

};

export default Select;